export const AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MAX_WIDTH = 288

export const AI_TEXT_GENERATION_FORMIK_BUTTON_SELECT_DROPDOWN_MIN_HEIGHT = 58
